import { editFlowTask } from '~src/app/actions/spaces/RunFlowTaskMenuActions';
import { AppState } from '~src/app/state/AppState';
import { hasRunNowPermission } from '~src/app/utils/MixedContentHelpers';
import { Messages } from '~src/codegen/Localize';
import { RunFlowTaskInfo } from '~src/ts/models/RunFlowTaskInfo';

import { EntityActionNames, IEntityAction } from './IEntityAction';

export const EditFlowTaskAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksEdit,
  translateName: Messages.editTask_action,
  isVisible: (targetItems: RunFlowTaskInfo[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length === 1 && hasRunNowPermission(state);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => editFlowTask(targetItems)
};
